import {css} from "@panda/css";

import {BrandSecretClientIcon} from "@pg-design/icons-module";

export const SemanticSearchClientIcon = () => {
    return (
        <div className={iconWrapper}>
            <BrandSecretClientIcon className={iconSize} />
        </div>
    );
};

const iconWrapper = css({
    display: "flex",
    justifyContent: "center",
    mb: 4
});

const iconSize = css({
    width: "21.4rem",
    height: "20.8rem",

    md: {
        width: "26.8rem",
        height: "26rem"
    }
});
import {css} from "@panda/css";

import {BrandSecretClientIcon} from "@pg-design/icons-module";

export const SemanticSearchClientIcon = () => {
    return (
        <div className={iconWrapper}>
            <BrandSecretClientIcon className={iconSize} />
        </div>
    );
};

const iconWrapper = css({
    display: "flex",
    justifyContent: "center",
    mb: 4
});

const iconSize = css({
    width: "21.4rem",
    height: "20.8rem",

    md: {
        width: "26.8rem",
        height: "26rem"
    }
});
